import * as zod from 'zod';

import { ModbusFunctionCodeEnum } from '@sb/integrations/utils/modbus/ModbusFunctionCode';

import { ModbusTCPRegisterData } from '../types';

// Read Request Types
export const ModbusTCPServerReadCoilsRequest = zod.object({
  kind: zod.literal(ModbusFunctionCodeEnum.ReadCoils),
  register: ModbusTCPRegisterData,
  variableIDList: zod.array(zod.string()),
  quantity: zod.number().optional(),
});

export const ModbusTCPServerReadDiscreteInputsRequest = zod.object({
  kind: zod.literal(ModbusFunctionCodeEnum.ReadDiscreteInputs),
  register: ModbusTCPRegisterData,
  variableIDList: zod.array(zod.string()),
  quantity: zod.number().optional(),
});

export const ModbusTCPServerReadHoldingRegistersRequest = zod.object({
  kind: zod.literal(ModbusFunctionCodeEnum.ReadHoldingRegisters),
  register: ModbusTCPRegisterData,
  variableIDList: zod.array(zod.string()),
  quantity: zod.number().optional(),
});

export const ModbusTCPServerReadInputRegistersRequest = zod.object({
  kind: zod.literal(ModbusFunctionCodeEnum.ReadInputRegisters),
  register: ModbusTCPRegisterData,
  variableIDList: zod.array(zod.string()),
  quantity: zod.number().optional(),
});

// Write Request Types
export const ModbusTCPServerWriteSingleCoilRequest = zod.object({
  kind: zod.literal(ModbusFunctionCodeEnum.WriteSingleCoil),
  register: ModbusTCPRegisterData,
  valueList: zod.array(zod.number()), // 0 or 1 for boolean
});

export const ModbusTCPServerWriteSingleRegisterRequest = zod.object({
  kind: zod.literal(ModbusFunctionCodeEnum.WriteSingleRegister),
  register: ModbusTCPRegisterData,
  valueList: zod.array(zod.number()),
});

export const ModbusTCPServerRequest = zod.union([
  ModbusTCPServerReadCoilsRequest,
  ModbusTCPServerReadDiscreteInputsRequest,
  ModbusTCPServerReadHoldingRegistersRequest,
  ModbusTCPServerReadInputRegistersRequest,
  ModbusTCPServerWriteSingleCoilRequest,
  ModbusTCPServerWriteSingleRegisterRequest,
]);

export const ModbusTCPServerCommand = zod.object({
  kind: zod.literal('ModbusTCPServer'),
  equipmentId: zod.string(),
  request: ModbusTCPServerRequest,
});

export type ModbusTCPServerRequest = zod.infer<typeof ModbusTCPServerRequest>;

// Read Request Type Exports
export type ModbusTCPServerReadCoilsRequest = zod.infer<
  typeof ModbusTCPServerReadCoilsRequest
>;

export type ModbusTCPServerReadDiscreteInputsRequest = zod.infer<
  typeof ModbusTCPServerReadDiscreteInputsRequest
>;

export type ModbusTCPServerReadHoldingRegistersRequest = zod.infer<
  typeof ModbusTCPServerReadHoldingRegistersRequest
>;

export type ModbusTCPServerReadInputRegistersRequest = zod.infer<
  typeof ModbusTCPServerReadInputRegistersRequest
>;

// Write Request Type Exports
export type ModbusTCPServerWriteSingleCoilRequest = zod.infer<
  typeof ModbusTCPServerWriteSingleCoilRequest
>;

export type ModbusTCPServerWriteSingleRegisterRequest = zod.infer<
  typeof ModbusTCPServerWriteSingleRegisterRequest
>;

export type ModbusTCPServerCommand = zod.infer<typeof ModbusTCPServerCommand>;

// Backwards compatibility aliases - now include all read/write types
export type ModbusTCPServerReadRequest =
  | ModbusTCPServerReadCoilsRequest
  | ModbusTCPServerReadDiscreteInputsRequest
  | ModbusTCPServerReadHoldingRegistersRequest
  | ModbusTCPServerReadInputRegistersRequest;

export type ModbusTCPServerWriteRequest =
  | ModbusTCPServerWriteSingleCoilRequest
  | ModbusTCPServerWriteSingleRegisterRequest;
